import { z } from "zod";

export const submitQuizSchema = z.object({
  quiz_id: z.number(),
  answers: z.array(
    z.object({
      question_id: z.number(),
      selected_options: z.array(z.string()),
    })
  ),
});
